import { useFormContext } from 'react-hook-form';

import palette from '@lib/core/src/theme/palette';
import { Button as MuiButton, ButtonProps, styled } from '@mui/material';

import { ButtonsWrapper } from '@/components/AiWorkflow/AiWorkflowStyles';

const Button = styled(MuiButton)({
  width: 101,
  height: 40,
  borderRadius: 20,
  padding: 12,
  border: 'unset',
  textTransform: 'none',
  fontSize: 12,
  color: palette.black,
  '&:disabled': {
    color: palette.white,
    backgroundColor: palette.grey[2500]
  }
});

const SaveButton = styled(Button)({
  backgroundColor: palette.black,
  color: palette.white,
  '&:hover': {
    backgroundColor: palette.grey[2600]
  }
});

interface FormButtonsProps extends ButtonProps {
  onCancel: () => void;
  submitText: string;
  isLoading: boolean;
}

export default function FormButtons({ submitText, onCancel, isLoading }: FormButtonsProps) {
  const {
    formState: { isSubmitting, isValid }
  } = useFormContext();

  return (
    <ButtonsWrapper>
      <Button variant="outlined" onClick={onCancel}>
        Cancel
      </Button>
      <SaveButton type="submit" disabled={isSubmitting || !isValid} loading={isLoading}>
        {submitText}
      </SaveButton>
    </ButtonsWrapper>
  );
}
